import moment from 'moment';

export function isNullOrWhitespace(input: string | null | undefined) {
  return !input || input.trim() === '';
}

export function stringToDate(input: string | null | undefined) {
  if (isNullOrWhitespace(input)) return null;

  const expiratedDate = moment(input);
  if (expiratedDate.isValid()) {
    return expiratedDate.toDate();
  }

  return null;
}

export function stringToBool(input: string | null | undefined) {
  if (isNullOrWhitespace(input)) return false;

  if (input?.toLowerCase() === 'true') return true;

  return false;
}


export function stringToNumberDefault1(input: string | null | undefined) {
  if (isNullOrWhitespace(input)) return 1;

  var num = Number(input);
  if (isNaN(num)) return 1;

  return num;
}
